import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastModule } from 'primeng/toast';
import { AuthService } from './core/services/auth.service';
import { getDefaultLanguage } from './core/types/language.types';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    TranslateModule,
    ToastModule
  ],
  template: `
    <p-toast position="top-right"></p-toast>
    <router-outlet></router-outlet>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
      height: 100%;
    }
  `]
})
export class AppComponent implements OnInit {
  title = 'SmileTaxi Admin';

  constructor(
    private translateService: TranslateService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Get saved language from localStorage or use browser language as fallback
    const savedLanguage = localStorage.getItem('language');
    const browserLanguage = this.translateService.getBrowserLang();

    // Supported languages
    const supportedLanguages = ['en', 'uk', 'lv', 'ru'];

    let language = getDefaultLanguage(); // Default fallback

    if (savedLanguage && supportedLanguages.includes(savedLanguage)) {
      // Use saved language if valid
      language = savedLanguage;
    } else if (browserLanguage && supportedLanguages.includes(browserLanguage)) {
      // Use browser language if no saved language and browser language is supported
      language = browserLanguage;
    }

    // English is always the fallback language (if current language file fails)
    this.translateService.setDefaultLang('en');
    this.translateService.use(language).subscribe({
      error: () => { /* translation load failed */ }
    });

    // Ensure localStorage has the current language
    localStorage.setItem('language', language);

    // Initialize AuthService (load statuses if authenticated)
    this.authService.initialize();
  }
}
